import { useFormStore } from '@/stores/form'
import apiHelperService from '@/services'
import { useGlobalStore } from '@/stores/global'

async function getEstabFines() {
  const formStore = useFormStore()
  const globalStore = useGlobalStore()
  const {
    serviceConfig: { mode }
  } = globalStore.startedService
  const {
    immigrationDepartmentId = '',
    delegateCardSequence = '',
    delegateCardYear = '',
    establishmentNumber = ''
  } = formStore.form.values
  if (mode == 'ProCard' && immigrationDepartmentId && delegateCardSequence && delegateCardYear) {
    getDelegateInfo()
    calculateFines()
  }
  if (['EstabCard', 'EstabBox'].includes(mode) && immigrationDepartmentId && establishmentNumber) {
    getEstablishmentInfo()
    calculateFines()
  }
}

async function getEstablishmentInfo() {
  const formStore = useFormStore()
  const { immigrationDepartmentId = '', establishmentNumber = '' } = formStore.form.values
  const res = await apiHelperService.post(`/api/establishment/estabNameAndRelatedPerson`, {
    immigrationDepartmentId,
    establishmentNumber
  })
  if (!res) return
  const { englishName = '', arabicName = '' } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    englishName,
    arabicName
  }
}

async function calculateFines() {
  const formStore = useFormStore()
  const {
    immigrationDepartmentId = '',
    delegateCardSequence = '',
    delegateCardYear = '',
    establishmentNumber = ''
  } = formStore.form.values
  const { serviceTransactionId } = formStore.extraMap
  const res = await apiHelperService.post(`/api/fines/draft/calculateEstabFines`, {
    serviceTransactionId,
    immigrationDepartmentId,
    establishmentNumber,
    delegateCardSequence,
    delegateCardYear
  })
  if (!res) return
  const { finesAmount = '', overstayDays = '' } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    finesAmount,
    overstayDays
  }
}

async function getDelegateInfo() {
  const formStore = useFormStore()
  const {
    immigrationDepartmentId = '',
    delegateCardSequence = '',
    delegateCardYear = ''
  } = formStore.form.values
  const res = await apiHelperService.post(`/api/establishment/delegate/information`, {
    sequance: delegateCardSequence,
    year: delegateCardYear,
    immigrationDepartmentId
  })
  if (!res) return
  const { englishName = '', arabicName = '' } = res
  formStore.draft.request = {
    ...formStore.draft.request,
    englishName,
    arabicName
  }
}
export default function (actionName, actionParams) {
  switch (actionName) {
    case 'getEstabFines':
      getEstabFines()
      break
    default:
      break
  }
}
